import * as React from 'react';
import { Link, RouteComponentProps, BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import * as hash from 'react-router';
import * as constants from '../const';

class Pagination extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            params: this.props.Params,
            pageNumberInput:''
        }
    }

    resetPagination() { // resetting pagination
        this.props.PaginationActions.onResetPagination();
    }

    loadData(component, pageNumber) { // loading data based on pagination event
        let filterObj = this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
            filterObj.byPagination = true;
        this.props.GetData(pageNumber, filterObj);
    }
    handlePagination(action, pageNumber) { // handling pagination events

        const { Component } = this.props;
        let component = Component;
        if (action === 'next') {
            this.loadData(component, pageNumber);
        } else if (action === 'prev') {
            this.loadData(component, pageNumber);
        } else if (action === 'first') {
            this.loadData(component, pageNumber);
        } else if (action === 'last') {
            this.loadData(component, pageNumber);
        }
    }
    
    render() {
        const { Component, currentPage, pageSize, ShowPagination } = this.props;

        return <div className={ShowPagination ? '' : 'hidden'}>
                   <div className="paginationContainer text-center">
                       <div className="input-group pagination">
                           <div className="input-group-btn paginationAction">
                                <button className="btn btn-default" type="button" onClick={() => this.handlePagination('first', 1)}
                                    disabled={currentPage === 1}>
                                    <i className="fa fa-angle-left"></i><i className="fa fa-angle-left"></i>
                                </button>
                                <button className="btn btn-default" type="button" onClick={() => this.handlePagination('prev', currentPage - 1)}
                                    disabled={currentPage === 1}><i className="fa fa-angle-left"></i>
                                </button>
                            </div>
                            <div className="input-group-btn paginationAction paginationLbl">
                                <span>Page {currentPage} of {pageSize}</span>
                            </div>
                            <div className="input-group-btn paginationAction">
                                <button className="btn btn-default" type="button" onClick={() => this.handlePagination('next', currentPage + 1)}
                                    disabled={currentPage === pageSize}><i className="fa fa-angle-right"></i>
                                </button>
                                <button className="btn btn-default" type="button" onClick={() => this.handlePagination('last', pageSize)}
                                    disabled={currentPage === pageSize}><i className="fa fa-angle-right"></i><i className="fa fa-angle-right"></i>
                                </button>
                           </div>
                       </div>
                   </div>
               </div>;
    }
}
function mapStateToProps(state) {
    return { PaginationState: state.Pagination, filterState:state.filter };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    })
}
export default connect(mapStateToProps, mapDispatchToProps)(Pagination);